export const FETCH_SETTING_SUCCESS = 'FETCH_SETTING_SUCCESS';
export const FETCH_WEEKLY_SETTING_M = 'FETCH_WEEKLY_SETTING_M';
export const FETCH_USER_PAGE_MSG_M = 'FETCH_USER_PAGE_MSG_M';
export const DUMMY_ACTION_M = 'DUMMY_ACTION_M';
